import React from "react";
import InviteHero from "./inviteHero";
import Referrer from "./referrer";
import InviteIntro from "./inviteIntro";
import DefaultReferral from "./defaultReferral";
import NavigateButtons from "./navigateButtons";
import DashBoard from "./dashBoard";
import InviteRecommend from "./inviteRecommend";
import InviteReferral from "./inviteReferral";
import InviteCashBack from "./inviteCashBack";

export default function Invite() {
  return (
    <div>
      {/* <InviteHero /> */}
      {/* <Referrer /> */}
      <InviteIntro />
      <DefaultReferral />
      <NavigateButtons />
      <DashBoard />
      <InviteRecommend />
      <InviteReferral />
      <InviteCashBack />
    </div>
  );
}
